import { Injectable } from '@angular/core';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { PlatformService } from '../platform/platform.service';

@Injectable()
export class LanguageService {

    public _language: BehaviorSubject<string> = new BehaviorSubject('fr');
    public language: Observable<string> = this._language.asObservable();

    constructor(public platformService: PlatformService, private route: ActivatedRoute, private router: Router) {
        this.router.events.subscribe(val => {
            if (val instanceof RoutesRecognized) {
                let urlLang;
                if (val.state.root.firstChild) urlLang = val.state.root.firstChild.params['lang'];
                let lang;
                if (this.platformService.isBrowser) {
                    lang = urlLang || this._language.value || navigator.language || (navigator as any).browserLanguage || 'fr';
                } else {
                    lang = urlLang || this._language.value || 'fr';
                }
                if (lang.toLowerCase() === 'fr' || lang.toLowerCase() === 'fr-fr') {
                    lang = 'fr';
                } else if (lang.toLowerCase() === 'zh' || lang.toLowerCase() === 'zh-cn' || lang.toLowerCase() === 'zh-tw') {
                    lang = 'zh';
                } else {
                    lang = 'en';
                }
                this._language.next(lang);
            }
        });
    }

    public getLanguage() {
        if (this._language.value === 'zh') {
            return '中国';
        } else {
            return this._language.value;
        }
    }

}